import getGdprCookieKey from 'rlink-cookies/getGDPRCookieKey';
import cookies from 'rlink-cookies/cookies';

export default function getGdprConsent (appName, gdprCookieVersion) {
  return typeof document !== 'undefined' ? cookies.getItem(getGdprCookieKey(appName, gdprCookieVersion)) : true;
}



// WEBPACK FOOTER //
// ./lib/rlink-cookies/getGdprConsent.js